import React, { useEffect, useState } from 'react'
import DashboardLayout from '../../components/layouts/dashboardLayout'
import { Breadcrumb } from 'react-bootstrap';
import RLDD from 'react-list-drag-and-drop/lib/RLDD';
import productsApi from "../../api/product";
import { Link, useNavigate } from 'react-router-dom';
import routes from '../../utils/routes';
import toast from 'react-hot-toast';
import { useSelector, useDispatch } from 'react-redux';
import Actions from '../../store/actions';
import moment from 'moment';
import { Waypoint } from 'react-waypoint';
import productApi from '../../api/product';
import { addIdToData } from '../../utils';


let updateInterval = ""

let ProductList = () => {
   let navigate = useNavigate()
   let products = useSelector(data => data.products);
   let setting = useSelector(data => data.profile.data.setting);
   let profile = useSelector(data => data.profile.data);
   let dispatch = useDispatch();

   const [loading, setLoading] = useState(false);
   const [page, setPage] = useState(products?.pageLoaded || 1);
   const [totalPages, setTotalPages] = useState(null);
   const [noMoreProducts, setNoMoreProducts] = useState(products?.allLoaded || false)


   const getData = (page) => {
      try {
         setLoading(true);
         productApi.getProducts(page)
            .then(async (res) => {
               if (res?.data?.error == false) {
                  if (products?.pageLoaded < res?.data?.data?.page) {
                     const newRecords = res?.data?.data?.data.filter(newRecord =>
                        !products.data.some(existingRecord => existingRecord._id === newRecord._id)
                     );
                     dispatch(Actions.addProductsList({
                        data: await addIdToData([...products.data, ...newRecords]),
                        pageLoaded: newRecords.length > 0 ? res?.data?.data?.page : products?.pageLoaded,
                        allLoaded: res?.data?.data?.data?.length < 10
                     }));
                  }
                  setTotalPages(res?.data?.data?.totalPages);
                  setLoading(false);
                  if (res?.data?.data?.data?.length < 10) {
                     setNoMoreProducts(true);
                  }
                  setPage(page)
               }
            })
            .catch(error => {
               console.log(error.message);
               setLoading(false);
            });
      } catch (error) {
         console.log(error.message);
         setLoading(false);
      }
   }


   let updateProductsListOrder = (list) => {
      try {
         productsApi.updateProductsListOrder({ products: list })
            .then(async (res) => {
               if (res?.status == 200) {
                  toast.success("Products order list updated successfully.");
               }
            })
            .catch((error) => {
               console.log(error.message)
               if (error?.response?.data?.msg) {
                  toast.error(error?.response?.data?.msg);
               } else {
                  toast.error("Products list updating failed error.");
               }
            });
      } catch (error) {
         console.log(error.message);
         toast.error("Services temporary down. Please try later.");
      }
   }

   return (
      <>
         <DashboardLayout>
            <div className="container-fluid mt-4">
               <div className="row">
                  <div className="col-12">
                     <Breadcrumb>
                        <Breadcrumb.Item href="#">
                           Dashboard
                        </Breadcrumb.Item>
                        <Breadcrumb.Item active>All Products</Breadcrumb.Item>
                     </Breadcrumb>
                  </div>
               </div>
               <div className="row">
                  <div className="col-12">
                     <div className="bg-white p-md-3 p-2 overflow-hidden">
                        <div className="d-flex justify-content-between border-bottom py-2">
                           <div>
                              <h4 className='pb-0'>All Products</h4>
                           </div>
                           <div>
                              <button
                                 onClick={() => {
                                    navigate(routes.addProduct)
                                 }}
                                 className='btn btn-dark rounded-0'>Add product</button>
                           </div>
                        </div>
                        {(products.loading || !products.loaded || products.data.length == 0) ? (
                           <div className='pageSimpleLoader'>
                              {products.loaded ? "No record found" : "Loading..."}
                           </div>
                        ) : (
                           <div className="py-2 overflow-hidden">
                              <RLDD
                                 items={products.data}
                                 itemRenderer={(data, index) => {
                                    return (
                                       <div className='product-card p-1 pmd-0 cursor-grab border rounded-3 mb-1 bg-white' key={data?._id}>
                                          <div className="d-flex flex-column flex-sm-row gap-3 p-1">
                                             {/* Product Image */}
                                             <div className="position-relative" style={{ minWidth: "120px" }}>
                                                <img src={data.image}
                                                   alt={data.title}
                                                   className="rounded"
                                                   style={{ height: "120px", width: "120px", objectFit: "cover" }} />
                                                <div className="position-absolute top-0 start-0 p-2">
                                                   <span className="badge bg-dark">{index + 1}</span>
                                                </div>
                                             </div>

                                             {/* Product Details */}
                                             <div className="flex-grow-1">
                                                <div className="d-flex flex-wrap justify-content-between align-items-start gap-2">
                                                   <h5 className="mb-1">
                                                      {data.title}
                                                   </h5>

                                                   {/* Action Buttons */}
                                                   <div className="d-flex gap-2">
                                                      <Link className="btn btn-sm bg-dark rounded-circle" to={routes.editProduct(data._id)}>
                                                         <i className="fas fa-pen text-white"></i>
                                                      </Link>
                                                      <a
                                                         className="btn btn-sm bg-dark rounded-circle"
                                                         href={"https://" + profile?.domain + `/product/${data.slug}`}
                                                         target="_blank" rel="noopener noreferrer">
                                                         <i className="fas fa-eye text-white"></i>
                                                      </a>
                                                      {/* <button className="btn btn-sm btn-dark rounded-circle">
                                                         <i className="fas fa-trash"></i>
                                                      </button> */}
                                                   </div>
                                                </div>

                                                <p className="text-muted small mb-3">{data.description}</p>

                                                <div className="d-flex flex-wrap gap-2 mb-2">
                                                   <span className="badge bg-dark">
                                                      {setting?.currencySymbol} {data?.sellPrice}
                                                   </span>
                                                   <span className="badge bg-secondary">
                                                      SKU: {data.sku}
                                                   </span>
                                                   <span className={`badge ${data.sell ? 'bg-success' : 'bg-danger'}`}>
                                                      {data.sell ? 'Active' : 'Inactive'}
                                                   </span>
                                                </div>

                                                {/* <div>
                                                   <small className="text-muted">
                                                      <i className="far fa-clock me-1"></i>
                                                      Created At: {moment(data.createdAt).format("DD-MM-YYYY hh:mm A")}
                                                   </small>
                                                </div> */}
                                                <div>
                                                   <small className="text-muted">
                                                      <i className="far fa-clock me-1"></i>
                                                      Last updated: {moment(data.updatedAt).format("DD-MM-YYYY hh:mm A")}
                                                   </small>
                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                    );
                                 }}
                                 onChange={(data) => {
                                    console.log(data);
                                    dispatch(Actions.addProductsList({ pageLoaded: page, data }));
                                    if (updateInterval) {
                                       clearTimeout(updateInterval)
                                    }
                                    updateInterval = setTimeout(async () => {
                                       updateProductsListOrder(await data.map((data, index) => {
                                          return { _id: data._id }
                                       }))
                                    }, 3000);
                                 }}
                              />
                           </div>
                        )}
                        {loading && (
                           <div className="d-flex justify-content-center align-items-center">
                              <small className="text-center">Loading...</small>
                           </div>
                        )}
                        {noMoreProducts ? <div className="d-flex justify-content-center align-items-center">
                           <small className="text-center">No more products</small>
                        </div> : <Waypoint
                           onEnter={() => !loading && (totalPages === null || page < totalPages) && getData(page + 1)}
                        />}

                     </div>
                  </div>
               </div>


            </div>
         </DashboardLayout>
      </>
   )
}

export default ProductList